<div *ngIf="passengerList?.length > 0">
  <div class="passenger-separator marv10"></div>
  <div 
    class="passenger-item marb6 d-flex ion-align-items-center ion-justify-content-between ion-padding-horizontal pad12-v" 
    *ngFor="let passenger of passengerList; let i = index"
  >
    <div class="d-flex ion-align-items-center flex-1">
      <div class="passenger-icon marr10">
        <img src="assets/images/bus-passenger.png" alt="passenger" class="passenger-img" />
      </div>
      <div>
        <div class="fs-3 font600 title-text-color marb5">
          <span *ngIf="showTitle && (passenger.Title || passenger.title)">{{ (passenger.Title || passenger.title) | titlecase }}. </span>{{ passenger.FirstName }} {{ passenger.LastName }}
        </div>
        <div class="fs-2 font500 card-secondary-text-color">
          {{ passenger.Gender }}{{ getAgeDisplay(passenger) ? ', ' + getAgeDisplay(passenger) : '' }}
        </div>
      </div>
    </div>
    <div class="d-flex ion-align-items-center">
      <div class="seat-info marr10" *ngIf="isSeatCancelled(passenger.SeatNumber || getSeatNumber(passenger, i)); else seatInfo">
        <span class="seat-number fs-3 font500 red-text-color text-no-wrap">
          Cancelled Seat : <span class="font500 red-text-color">{{ passenger.SeatNumber || getSeatNumber(passenger, i) }}</span>
        </span>
      </div>
      <ng-template #seatInfo>
        <div class="seat-info marr10" *ngIf="passenger.SeatNumber || getSeatNumber(passenger, i)">
          <span class="seat-number fs-3 font500 card-secondary-text-color text-no-wrap">
           Seat : <span class="font500 title-text-color">{{ passenger.SeatNumber || getSeatNumber(passenger, i) }}</span>
          </span>
        </div>
      </ng-template>

      <ion-button
        *ngIf="showEdit"
        fill="clear"
        class="edit-btn mar0"
        (click)="handleEdit(passenger)"
      >
        <ion-icon name="create-outline" class="fs-4 primary-icon-color"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>